import { styled } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 0;
  gap: 20px;
`;

export const BlogWrapper = styled.div`
  width: 100%;
  padding: 10px 0;
`;

export const Text = styled.div`
  font-size: 12.11px;
  font-weight: 500;
  line-height: 18.16px;
  text-align: center;
  color: #267dff;
`;
export const Heading = styled.div`
  color: #222737;
  font-size: 31px;
  font-weight: 600;
  line-height: 39.35px;
  text-align: center;
  width: 100%;
`;
